import type { ReactNode } from 'react';
import React from 'react';

import classNames from 'classnames';

import { Spinner } from 'components/Spinner/Spinner';

import './SpinnerOverlay.scss';

type SpinnerOverlayProps = {
  children?: ReactNode;
  className?: string;
  message?: string;
};

const SpinnerOverlay = ({
  message,
  children,
  className,
}: SpinnerOverlayProps) => {
  const spinnerOverlayClassName = classNames('SpinnerOverlay', className);

  return (
    <div className={spinnerOverlayClassName}>
      <Spinner />
      {message && <span className="SpinnerOverlay-message">{message}</span>}
      {children}
    </div>
  );
};

export { SpinnerOverlay };
